import { ReadOnlyBadge } from '@/components/settings/ResourceLimits/ReadOnlyBadge'

interface ResourceLimitsHeaderProps {
  roomId: string
  title: string
  isGameCompleted?: boolean
}

export function ResourceLimitsHeader({
  roomId: _roomId,
  title,
  isGameCompleted = false,
}: ResourceLimitsHeaderProps) {
  return (
    <div className='flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between'>
      <div className='flex gap-3 items-center'>
        <div>
          <h1 className='text-2xl font-bold text-dark-blue'>{title}</h1>
        </div>
      </div>
      {isGameCompleted && <ReadOnlyBadge />}
    </div>
  )
}
